import filterTypeEnum from "../../../../components/Filter/enumerations/filterTypeEnum";
import { filterKeyFinancialHeader } from "./filterKeyEnum";

const filterSetupFinancialHeader = {
  filter_type: 2,
  filters: [
    {
      title: "date",
      type: filterTypeEnum.DATE_TIME_RANGE,
      //IF type=DATE_TIME_RANGE, data_index will eat 2 values [start_date, end_date]
      data_index: [
        filterKeyFinancialHeader.START_DATE,
        filterKeyFinancialHeader.END_DATE,
      ],
      required: true,
      precision: "day",
    },
  ],
};

export { filterSetupFinancialHeader };
